var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-complete"},[_vm._v("\n\t该文档未完成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }